import { a } from "../utils";

export const setLoginUser = (user: { username: string, token: string, roles?: Array<"admin"> }) => a({ type: "SET_USER", user });
export const deleteLoginUser = () => a({ type: "DELETE_USER", user: { username: "", token: "" } });